var _style, _g, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandResetTap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes handIn {\n      0%, 15% { opacity: 1; }\n      18% { opacity: 1; }\n      32% { opacity: 1; }\n      35% { opacity: 1; }\n      45%, 100% { opacity: 1; }\n    }\n    @keyframes tapDot {\n      0%, 15% { opacity: 0; }\n      16% { opacity: 1; }\n      32% { opacity: 1; }\n      33% { opacity: 0; }\n      100% { opacity: 0; }\n    }\n    @keyframes tapRing {\n      0%, 18% { r: 6; opacity: 0; }\n      22% { r: 6; opacity: 0.5; }\n      42% { r: 35; opacity: 0; }\n      100% { opacity: 0; }\n    }\n    @keyframes outerRing {\n      0%, 20% { r: 10; opacity: 0; }\n      26% { r: 10; opacity: 0.3; }\n      38% { r: 16; opacity: 0; }\n      100% { opacity: 0; }\n    }\n    .hand { animation: handIn 3s ease-in-out infinite; }\n    .td { animation: tapDot 3s ease-in-out infinite; }\n    .tr { animation: tapRing 3s ease-out infinite; }\n    .or { animation: outerRing 3s ease-in-out infinite; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hand",
    transform: "translate(35, 40) scale(0.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    stroke: "#eee",
    strokeWidth: 2,
    d: "M341.4,427.7c-26.6,9.7-51.8,11.1-75.7,4.2-23.9-6.8-46.5-23.1-67.8-48.9l-53.6-64.6c-1.1-1.3-2.1-2.7-3-4.4-.9-1.7-1.7-3.5-2.4-5.4-2.3-6.3-2.1-12.3.7-17.7,2.8-5.5,7.4-9.4,13.8-11.7,5.5-2,10.4-2,14.9-.1,4.4,1.9,8.4,4.6,11.8,8.3l34.1,37.1c1.2,1.3,2.3,1.7,3.5,1.3.8-.3,1.3-.8,1.5-1.6.2-.8,0-1.7-.3-2.8l-52.9-145.2c-2.3-6.3-2.3-12.3,0-17.8,2.4-5.5,6.7-9.4,12.8-11.6,5.8-2.1,11.3-1.9,16.7.9,5.4,2.7,9.2,7.3,11.4,13.6l37.6,103.3c.7,2,1.5,3.3,2.6,4s2.1.9,3.3.5c1-.4,1.6-1.2,1.9-2.5.3-1.3,0-2.8-.6-4.7l-11.9-32.7c-2.7-7.4,0-12.6,8.2-15.7,8.1-2.9,15.5-2.7,22,.7,6.6,3.4,11.5,9.5,14.7,18.3l5.6,15.1c.8,2.1,1.7,3.6,2.7,4.2,1,.7,2.2.8,3.4.3,1-.4,1.6-1.2,1.9-2.3s0-2.8-.7-4.8l-5.9-16.3c-2.7-7.6,0-12.9,8.2-15.8,7.7-2.8,15-2.5,22,1.1,6.9,3.6,12,9.6,15.1,18.1l2.6,7.5c.8,2.1,1.7,3.4,2.7,4.1,1,.7,2.1.8,3.3.4,1.1-.4,1.8-1.2,2.1-2.4.3-1.2,0-2.8-.6-4.8l-4.2-11.7c-2.1-5.7-.3-9.6,5.4-11.7,8.7-3.1,17.5-1.4,26.4,5.1,8.9,6.5,15.8,16.3,20.6,29.4l10.8,29.7c8.4,23.3,11.4,44.8,9.2,64.5-2.3,19.7-9.7,36.8-22.2,51.4-12.5,14.6-29.8,26-51.9,34.1Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "td",
    cx: 80,
    cy: 80,
    r: 10,
    fill: "#888"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "or",
    cx: 80,
    cy: 80,
    r: 13,
    fill: "none",
    stroke: "#999",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "tr",
    cx: 80,
    cy: 80,
    r: 10,
    fill: "none",
    stroke: "#999",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandResetTap);
export default __webpack_public_path__ + "static/media/hand-reset-tap.b4dd2d606dadb3900a2cc92fbdc129b1.svg";
export { ForwardRef as ReactComponent };